module.exports = __webpack_public_path__ + "img/kernel-bg.b3a61fd2.png";